
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conferences/[entityId]/videos/[...slug]",
      function () {
        return require("private-next-pages/conferences/[entityId]/videos/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conferences/[entityId]/videos/[...slug]"])
      });
    }
  